<div class="scenarios-list-container">
  <div class="layer-info" *ngFor="let scenario of scenarios; let isLastItem = last">
    <wlm-scenario-item
      class="scenario-container"
      [innerItemClass]="'layer-item-inner ' + (isLastItem ? 'layer-item-inner-last' : '')"
      [scenario]="scenario"
      [map]="map"
      (scenarioVisibilityChange)="onScenarioVisibilityChange($event)"
    ></wlm-scenario-item>
  </div>
</div>
